import { render, staticRenderFns } from "./IntegrationsLayout.vue?vue&type=template&id=2bc58bee&scoped=true"
import script from "./IntegrationsLayout.vue?vue&type=script&lang=js"
export * from "./IntegrationsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc58bee",
  null
  
)

export default component.exports